import {
  Creation,
  CreationCreateParams,
  CreationDebugger,
  CreationFileDetailInfo,
  CreationFileInfo,
  CreationSimple,
  CreationToolType,
  CreationWorkVersion,
  WorkDebuggerVersion,
  DraftsRes,
  CreationRecommend,
  CaptionRes,
} from '../../../entities';
import { VAxios } from '../../define/axios/Axios';
import { PageWrapper } from '../../entities/base/base.entities';
import { ErrorMessageMode } from '/#/axios';

export const createApi = (defHttp: VAxios) => ({
  //#region 智能创作
  // 获取智能创作记录列表
  getCreationList: (params) => {
    return defHttp.get<PageWrapper<CreationSimple>>({ url: '/aiad/work/creations', params });
  },

  getMyCreationList: (params) => {
    if (params.creationTypes === '') {
      params.creationTypes = [];
    }
    if (!Array.isArray(params.creationTypes)) {
      params.creationTypes = params.creationTypes?.split(',');
    }
    return defHttp.post<PageWrapper<CreationSimple>>({ url: '/aiad/creations', params });
  },

  // 查询推荐风格配置
  getCreationRecommends: () => {
    return defHttp.get<CreationRecommend[]>({
      url: '/aiad/creations/style/recommends',
    });
  },

  // 识图转文
  caption: (params: { imageUrl: string }) => {
    return defHttp.post<CaptionRes>({
      url: '/aiad/creations/caption',
      params,
    });
  },

  // 识图转文
  captionMJ: (params: { imageUrl: string }) => {
    return defHttp.post<CaptionRes>({
      url: '/aiad/creations/caption/pro',
      params,
    });
  },

  // 获取创作详情
  getCreation: (id) => {
    return defHttp.get<Creation>({ url: `/aiad/work/creations/${id}` });
  },
  // 获取创作记录任务，查单个（id 为 job id）
  getCreationJobs: (creationId, jobId) => {
    return defHttp.get<Creation>({ url: `/aiad/work/creations/${creationId}/jobs/${jobId}` });
  },
  // 生成创作，新建作品
  addCreation: (params?: CreationCreateParams) => {
    return defHttp.post({ url: '/aiad/work/creations', params });
  },
  // 修改创作
  updateCreation: (id, params: CreationCreateParams) => {
    return defHttp.put({ url: `/aiad/work/creations/${id}`, params });
  },
  // 删除创作
  deleteCreation: (id: string) => {
    return defHttp.delete({ url: `/aiad/work/creations/${id}` });
  },
  // 获取创作的所有文件
  getCreationFiles: (id, params) => {
    return defHttp.get<CreationFileInfo[]>({ url: `/aiad/work/creations/${id}/files`, params });
  },
  // 获取文件详情
  getCreationFileDetail: (creationId, fileId) => {
    return defHttp.get<CreationFileDetailInfo>({
      url: `/aiad/work/creations/${creationId}/files/${fileId}`,
    });
  },

  // 上传文件
  fileUpload(id, params) {
    return defHttp.post({
      url: `/aiad/work/creations/${id}/files`,
      params,
    });
  },

  // 新建任务
  createJob: (
    id: string | number,
    params: {
      ability: CreationToolType;
      debugger: CreationDebugger;
      num?: number;
      reiterate?: boolean;
    },
    errorMessageMode?: ErrorMessageMode,
  ) => {
    if (params.debugger) {
      params.debugger.version = WorkDebuggerVersion;
    }
    return defHttp.post({ url: `/aiad/work/creations/${id}/jobs`, params }, { errorMessageMode });
  },

  // 修改任务
  updateJob: (
    id: string | number,
    params: {
      ability: CreationToolType;
      debugger: CreationDebugger;
      num?: number;
      reiterate?: boolean;
    },
  ) => {
    return defHttp.put({ url: `/aiad/work/creations/${id}/jobs`, params });
  },

  // 保存为正式作品
  saveCreationWork: (id: string | number) => {
    return defHttp.post({ url: `/aiad/work/creations/${id}/save` });
  },

  // 作品版本信息
  getCreationWorkVersions: (
    id,
    params: {
      afterId?: string | number;
      page?: number;
      ability?: string;
      day?: string;
    },
  ) => {
    return defHttp.get<CreationWorkVersion[]>({
      url: `/aiad/work/creations/${id}/versions/page`,
      params,
    });
  },

  // 创作版本信息所有日期
  getVersionDays: (
    id,
    params?: {
      ability: string;
    },
  ) => {
    return defHttp.get({
      url: `/aiad/creations/common/${id}/version/days`,
      params,
    });
  },

  // 修改作品图片信息
  updateImage: (
    id: string | number,
    params?: {
      sourceId: string | null;
      sourceType: string | null;
      url: string;
    },
  ) => {
    return defHttp.put({ url: `/aiad/work/creations/${id}/image`, params });
  },

  // 修改智能创作作品图片信息
  updateSmartImage: (
    id: string | number,
    params?: {
      sourceId: string | null;
      sourceType: string | null;
      url: string;
    },
  ) => {
    return defHttp.put({ url: `/aiad/work/creations/${id}/editor/image`, params });
  },

  // 更改作品标记
  updateMark: (id, fileId, mark) => {
    return defHttp.put({
      url: `/aiad/work/creations/${id}/files/${fileId}/mark`,
      data: mark,
    });
  },
  // 删除标记
  deleteMark: (id, fileId) => {
    return defHttp.delete({ url: `/aiad/work/creations/${id}/files/${fileId}/mark` });
  },

  // 超分下载
  superResolutionDownload: (creationId, fileId, multiple) => {
    return defHttp.post({
      url: `/aiad/work/creations/${creationId}/files/${fileId}/download`,
      data: multiple + '',
    });
  },

  // 复制记录
  copyLog: (creationId, fileId) => {
    return defHttp.post({
      url: `/aiad/work/creations/${creationId}/files/${fileId}/copy`,
    });
  },
  //#endregion

  //#region 智能编辑
  // 提交智能编辑结果
  saveFileByUrl: (
    id,
    params: {
      ability?: string;
      referenceId?: string;
      referenceUrl: string;
      referenceType: string;
      type: 'reference' | 'work';
      url: string;
    },
  ) => {
    return defHttp.post<CreationFileDetailInfo>({
      url: `/aiad/work/creations/${id}/editors`,
      params,
    });
  },
  // 获取智能替换使用的模型
  getModel: (id) => defHttp.get({ url: `/aiad/work/creations/${id}/inpaint-model` }),

  // 获取智能替换使用的模型
  getModelDetail: (id) =>
    defHttp.get<{
      baseModel: string;
      modelStyles: string;
      modelStylesTriggers: string;
    }>({ url: `/aiad/work/creations/${id}/editor/model` }),

  //#endregion

  // 获取上传 work 的sts
  getWorkSTS: (id) => defHttp.get({ url: `/aiad/work/creations/${id}/upload` }),

  // 获取草图列表
  getDrafts: (id: string) => defHttp.get<DraftsRes[]>({ url: `/aiad/work/creations/${id}/drafts` }),

  // 新增草图
  addDraft: (
    id: string,
    params: {
      design?: Record<string, unknown>;
      image?: {
        height?: number;
        size?: number;
        url: string;
        width?: number;
      };
    },
  ) => defHttp.post({ url: `/aiad/work/creations/${id}/drafts`, params }),

  // 修改草图
  updateDraft: (
    draftId: string,
    id: string,
    params: {
      design?: Record<string, unknown>;
      image?: {
        height?: number;
        size?: number;
        url: string;
        width?: number;
      };
    },
  ) => defHttp.put({ url: `/aiad/work/creations/${draftId}/drafts/${id}`, params }),

  // 删除草图
  deleteDraft: (draftId: string, id: string) =>
    defHttp.delete({ url: `/aiad/work/creations/${draftId}/drafts/${id}` }),

  // 获取 mockup 模板
  getMockupTemplates: (params?) => defHttp.get({ url: `/aiad/mockup`, params }),

  // 获取我的 mockup 模板
  getMyMockupTemplates: (params?) => defHttp.get({ url: `/aiad/mockup/my`, params }),

  // 添加我的 mockup 模板
  addMyMockupTemplate: (params) => defHttp.post({ url: '/aiad/mockup/my/save', params }),

  // 获取创作详情
  segBody: (
    id: string,
    params: {
      url: string;
    },
  ) => {
    return defHttp.post<{
      dresses: string;
      lowerBody: string;
      upperBody: string;
    }>({ url: `/aiad/creations/${id}/seg-body?url=${params.url}` });
  },
});
